import { render, staticRenderFns } from "./screenshot-zip-upload.vue?vue&type=template&id=afa46910&scoped=true&"
import script from "./screenshot-zip-upload.vue?vue&type=script&lang=js&"
export * from "./screenshot-zip-upload.vue?vue&type=script&lang=js&"
import style0 from "./screenshot-zip-upload.vue?vue&type=style&index=0&id=afa46910&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa46910",
  null
  
)

export default component.exports